import { getRoutePath } from "@/router/routes";
import { Menu } from "@/typescript/models/store_menus/types";

const menuIconBasePath = "/images/components/layout";

export const storeMenus = (): Menu[] => {
  return [
    {
      id: 0,
      name: "温度管理",
      pageName: "TempManagementsImagePage",
      onIcon: `${menuIconBasePath}/ic_menu_thermal-management-on.png`,
      offIcon: `${menuIconBasePath}/ic_menu_thermal-management-off.png`
    },
    {
      id: 1,
      name: "警報履歴",
      pageName: "WarningHistoriesPage",
      onIcon: `${menuIconBasePath}/ic_menu_warning-history-on.png`,
      offIcon: `${menuIconBasePath}/ic_menu_warning-history-off.png`
    },
    {
      id: 2,
      name: "温度グラフ",
      pageName: "TempGraphsPage",
      onIcon: `${menuIconBasePath}/ic_menu_graph-on.png`,
      offIcon: `${menuIconBasePath}/ic_menu_graph-off.png`
    },
    {
      id: 3,
      name: "レポート",
      pageName: "ReportsPage",
      onIcon: `${menuIconBasePath}/ic_menu_report-on.png`,
      offIcon: `${menuIconBasePath}/ic_menu_report-off.png`
    },
    {
      id: 4,
      name: "センサ配置図",
      pageName: "SensorDiagramsShowPage",
      onIcon: `${menuIconBasePath}/ic_menu_ground-plan-on.png`,
      offIcon: `${menuIconBasePath}/ic_menu_ground-plan-off.png`
    },
    {
      id: 5,
      name: "設定",
      pageName: "SensorsShowPage",
      onIcon: `${menuIconBasePath}/ic_menu_setting-on.png`,
      offIcon: `${menuIconBasePath}/ic_menu_setting-off.png`
    },
    {
      id: 6,
      name: "店舗管理",
      pageName: "MasterManagementsPage",
      onIcon: `${menuIconBasePath}/ic_menu_master-on.png`,
      offIcon: `${menuIconBasePath}/ic_menu_master-off.png`
    }
  ];
};

// 店舗が保持する全てのメニュー情報を返却する
export const getStoreMenus = (storeId: number, currentId: number): Menu[] => {
  return storeMenus().map(sm => {
    sm.path = getRoutePath(sm.pageName, { store_id: storeId });
    sm.iconPath = currentId === sm.id ? sm.onIcon : sm.offIcon;
    return sm;
  });
};
